export default {"src":"/_next/static/media/app-app-store-black.2f618115.svg","height":40,"width":121,"blurWidth":0,"blurHeight":0};